import React, { useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  IconButton,
  Hidden,
  Icon,
  Toolbar,
  List,
} from "@material-ui/core";
import LogoWhite from "assets/images/logo.png";
import {
  AppBar,
  Logo,
  DrawerMenu,
  Menu,
  MenuItem,
  DrawerContainer,
  DrawerListItem,
  DrawerListFooter,
  DrawerListHeader,
  FooterLogout,
  Account,
  LogoContainer,
} from "./styles";
import { Icons } from "components/Icons";
import { useRouter, useConfig } from "hooks";
import { useSession } from "context/SessionContext";
import SideMenuItem from "../SidebarDrawer/SideMenu/SideMenuItem";
import LogoName from "assets/images/modulocker.png";

type Anchor = "top" | "left" | "bottom" | "right";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      width: theme.spacing(10),
      height: theme.spacing(10),
    },
    avatarLgDevice: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(4),
    },
    logoutItem: {
      color: "var(--black)",
      height: "32px",
      justifyContent: "center !important",
      paddingLeft: "0",
      width: "calc(100% - 16px)",
    },
    iconMiddle: {
      color: "var(--white)",
      verticalAlign: "middle",
      marginLeft: theme.spacing(1),
    },
    iconFooter: {
      color: "var(--black)",
      verticalAlign: "middle",
      marginLeft: theme.spacing(1),
      fontSize: "16px",
    },
    notificationIcon: {
      marginLeft: "1.2rem",
      padding: "12px 0 12px 12px",
      [theme.breakpoints.down("sm")]: {
        marginLeft: "0",
      },
      "& .MuiSvgIcon-fontSizeLarge": {
        fontSize: "3rem",
      },
    },
    userButton: {
      // color: 'var(--white)',
      fontSize: "1.4rem",
      textTransform: "inherit",
    },
  })
);

export default function Navbar() {
  const [state, setState] = useState({ left: false });
  const [anchorEl, setAnchorEl] = useState(false);
  const { signOut } = useSession();
  const { menus }: any = useConfig();
  const classes = useStyles();
  const router = useRouter();

  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, left: open });
    };

  const handleClick = () => {
    setAnchorEl(!anchorEl);
  };
  const handleLogout = () => {
    signOut();
    router.push("/");
  };

  const handleDrawer = () => {
    setState({ ...state, left: !state.left });
  };

  const MobileMenu = (anchor: Anchor) => (
    <DrawerContainer role="presentation">
      <DrawerListHeader style={{ background: "var(--backgroundContent)" }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          m={2}
        >
          <LogoContainer>
            <img src={LogoName} alt="Modulocker" />
          </LogoContainer>
          {/* <UserEmail>EasyTech</UserEmail> */}
        </Box>
      </DrawerListHeader>

      <List style={{ padding: "8px" }}>
        {menus?.map((menu: any, index: any) => (
          <SideMenuItem
            key={index}
            {...menu}
            onDrawer={handleDrawer}
            expanded
          />
        ))}
      </List>

      <DrawerListFooter style={{ background: "var(--backgroundContent)" }}>
        <DrawerListItem
          className={classes.logoutItem}
          button
          onClick={() => handleLogout()}
        >
          <FooterLogout>
            <span>Encerrar Sessão</span>
            <Icon className={classes.iconFooter} fontSize="inherit">
              logout
            </Icon>
          </FooterLogout>
        </DrawerListItem>
      </DrawerListFooter>
    </DrawerContainer>
  );

  return (
    <AppBar style={{ zIndex: 10 }}>
      <Toolbar>
        <DrawerMenu
          style={{ zIndex: 11 }}
          anchor="left"
          open={state.left}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          {MobileMenu("left")}
        </DrawerMenu>

        <Box
          width="100%"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Hidden mdUp>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer(true)}
            >
              <Icons.Menu fontSize="large" />
            </IconButton>
          </Hidden>

          <Hidden smDown>
            <Box display="flex" justifyContent="center">
              <Logo src={LogoWhite} alt="flexaseal logo" />
            </Box>
          </Hidden>

          <Hidden smDown>
            <Box display="flex" alignItems="center" position="relative">
              <Button
                className={classes.userButton}
                ref={anchorRef}
                onClick={handleClick}
              >
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Account>felipe.rosa@edesoft.com</Account>
                  <Icons.ExpandMore
                    className={classes.iconMiddle}
                    fontSize="large"
                  />
                </Box>
              </Button>

              {anchorEl && (
                <Menu onMouseLeave={() => setAnchorEl(false)}>
                  <MenuItem onClick={() => handleLogout()}>
                    Encerrar Sessão
                  </MenuItem>
                </Menu>
              )}
            </Box>
          </Hidden>

          <Hidden mdUp>
            <Box display="flex" justifyContent="center">
              <Logo src={LogoWhite} alt="flexaseal logo" />
            </Box>
          </Hidden>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
